module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-bloc', [_c('h3', {
    staticClass: "mg-sm text-center"
  }, [_vm._v("\n\t\t  Coneron\n\t  ")])]), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('h2', {
    staticClass: "mg-sm text-center"
  }, [_vm._v("\n        Unohditko salasanasi?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n            Sähköposti\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-deep-magenta",
    on: {
      "click": function($event) {
        _vm.sendPassword(_vm.user.email)
      }
    }
  }, [_vm._v("Lähetä")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6ec2c2d7"}!./src/app/pages/login-reset-password/login-reset-password.html
// module id = 487
// module chunks = 1